import {makeAutoObservable} from 'mobx';
import {fromPromise, IPromiseBasedObservable} from 'mobx-utils';
import {LoginUserType} from '@wp-content-publisher/typings-lib';
import {login, logOut} from '../api/login.ts';

const initFormData: LoginUserType = {
    email: '',
    password: '',
}

class LoginPageStore {

    formData: LoginUserType = {...initFormData};

    loginSubmitStatus: IPromiseBasedObservable<{
        state: 'pending' | 'resolved' | 'rejected',
        value: { access_token: string }
    }> | null = null;

    logOutSubmitStatus: IPromiseBasedObservable<{
        state: 'pending' | 'resolved' | 'rejected'
    }> | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    setFormData = (inputData: LoginUserType) => {
        this.formData = {...this.formData, ...inputData};
    }

    submitForm = async () => {
        this.loginSubmitStatus = fromPromise(
            login(this.formData)
                .catch(error => {
                    console.log(error)
                    throw error.message || 'Ошибка сервера';
                })
        ) as any;
        this.logOutSubmitStatus = null;
    }

    reset = () => {
        this.formData = {...initFormData};
    }

    logOut = async () => {
        this.logOutSubmitStatus = fromPromise(
            logOut()
                .catch(error => {
                    console.log(error)
                    throw error.message || 'Ошибка сервера';
                })
        ) as any
        this.loginSubmitStatus = null

    }
}

const loginPageStore = new LoginPageStore();
export {loginPageStore};